import React from 'react';
import RegistrationManagement from '../RegistrationManagement';
import { Widget } from './Common';

function UserManagementView() {
  return (
    <Widget>
      <RegistrationManagement />
    </Widget>
  );
}
export default UserManagementView;